import AutoQuery from "servicestack/auto-query/auto-query";
import keyBy from "lodash/keyBy";
import basicController from "servicestack/basic.controller.properties";
import modals from "webmodals/modals";
import labels from "emun.auth/permissions/_labels";
import PermissionListPrompt from "emun.auth/permissions/permission-list-prompt";

export default class PermissionListManagerController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.labels = labels;
  }

  $onInit() {
    const $ctrl = this;

    $ctrl.query = new AutoQuery({
      url: "QueryPermissionLists.json",
      hideLeftNav: true, // $ctrl.$page.is('gt-sm'),
      orderBy: "-CreatedOn,Id",
      sortOptions: {
        "CreatedOn,Id": "Created: Newest",
        "-CreatedOn,Id": "Created: Oldest",
        Label: "Label: A to Z",
        "-Label": "Label: Z to A",
        "ItemCount,Id": "Items: A to Z",
        "-ItemCount,Id": "Items: Z to A"
      },
      autoLoad: true,
      pageSize: 12
    });
    $ctrl.query.bus
      .read("QueryPermissions.json")
      .then(r => ($ctrl.permissions = keyBy(r.data.results, "code")));
  }

  create() {
    const $ctrl = this;
    PermissionListPrompt({ request: {} }).then(() => $ctrl.query.load(true));
  }

  edit(list) {
    const $ctrl = this;
    PermissionListPrompt({ request: list }).then(() => $ctrl.query.load(true));
  }

  delete(list) {
    const $ctrl = this;
    return modals
      .confirm("Are you sure?", "Delete Permission List")
      .result.then(function() {
        $ctrl.query.bus
          .send("DeletePermissionList.json", list)
          .then(function(response) {
            $ctrl.query.load(true);
          });
      });
  }
}
